var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 492,
    viewBox: "0 0 295 492",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.991 243.886C490.835 108.029 379.765 -1.1585 243.908 0.00928064C108.051 1.17707 -1.14638 112.258 0.00908585 248.114C1.16455 383.971 112.235 493.159 248.092 491.991C383.949 490.823 493.146 379.742 491.991 243.886ZM375.009 243.454C374.387 170.33 314.917 111.557 242.179 112.182C169.441 112.807 110.979 172.594 111.601 245.719C112.223 318.844 171.693 377.616 244.431 376.991C317.169 376.366 375.631 316.579 375.009 243.454Z",
    fill: "#FF6000",
    fillOpacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.b4093464e0910e61c0b1822f923786cf.svg";
export { ForwardRef as ReactComponent };